var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoMessageActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7058 3.03368C12.487 2.97856 11.2376 2.99114 10.0352 3.07107C5.8522 3.34913 2.52022 6.72838 2.24605 10.9707C2.1924 11.8009 2.1924 12.6607 2.24605 13.4909C2.34591 15.036 3.02924 16.4666 3.83372 17.6746C4.30082 18.5203 3.99255 19.5758 3.50602 20.4978C3.15522 21.1626 2.97982 21.495 3.12065 21.7351C3.26149 21.9752 3.57607 21.9829 4.20524 21.9982C5.44948 22.0285 6.28849 21.6757 6.95449 21.1846C7.33221 20.9061 7.52108 20.7668 7.65125 20.7508C7.78141 20.7348 8.03758 20.8403 8.54982 21.0513C9.01021 21.2409 9.54477 21.3579 10.0352 21.3905C11.4594 21.4852 12.9493 21.4854 14.3764 21.3905C18.5594 21.1125 21.8914 17.7332 22.1656 13.4909C22.1867 13.164 22.1995 12.8325 22.204 12.5",
    stroke: "#3F51B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70581 15H15.7058M8.70581 10H12.2058",
    stroke: "#3F51B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2058 7.5C16.6973 8.0057 18.0056 10 18.7058 10M18.7058 10C19.406 10 20.7143 8.0057 21.2058 7.5M18.7058 10V2",
    stroke: "#3F51B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoMessageActive);
export default __webpack_public_path__ + "static/media/auto-message-active.372be4f6326104938cef666877438bb8.svg";
export { ForwardRef as ReactComponent };